import { ColumnHelper } from "@tanstack/react-table";
import { GenerateColumnsFn } from "PFComponents/table/table.types";
import { useCallback } from "react";

import { Report } from "../../../types/reports";
import { ReportsTableTab } from "../reports_page";
import { useReportsColumnsGenerator } from "./use_reports_columns_generator";

type UseReportsColumns = {
  generateColumns: (filter: ReportsTableTab) => GenerateColumnsFn<Report>;
};

export const useReportsColumns = (): UseReportsColumns => {
  const { reportNameColumn, templateColumn, creationDateColumn, actionColumn } = useReportsColumnsGenerator();
  const generateColumns = useCallback(
    (filter: ReportsTableTab) => (columnHelper: ColumnHelper<Report>) => {
      if (filter === ReportsTableTab.All) {
        return [
          reportNameColumn(columnHelper),
          templateColumn(columnHelper),
          creationDateColumn(columnHelper),
          actionColumn(columnHelper)
        ];
      }
      if (filter === ReportsTableTab.Scheduled) {
        return [reportNameColumn(columnHelper), templateColumn(columnHelper), actionColumn(columnHelper)];
      }
      if (filter === ReportsTableTab.NotScheduled) {
        return [
          reportNameColumn(columnHelper),
          templateColumn(columnHelper),
          creationDateColumn(columnHelper),
          actionColumn(columnHelper)
        ];
      }
      return [];
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return {
    generateColumns
  };
};
